import { IPaginatedRequest } from '@cbgms/api/request'
import { IBankHoliday, ICreateBankHoliday, ICreateRegionTag, IRegionTag } from '.'

export const listBankHolidays = (params: IPaginatedRequest) => ({
  method: 'GET',
  url: '/modules/bank-holidays/days',
  params
})

export const listRegionTags = (params: IPaginatedRequest) => ({
  method: 'GET',
  url: '/modules/bank-holidays/region-tags',
  params
})

export const getBankHoliday = (bankHolidayUUID: string) => ({
  method: 'GET',
  url: `/modules/bank-holidays/days/${bankHolidayUUID}`
})

export const getRegionTag = (regionTagUUID: string) => ({
  method: 'GET',
  url: `/modules/bank-holidays/region-tags/${regionTagUUID}`
})

export const updateBankHoliday = (bankHolidayUUID: string, data: Partial<IBankHoliday>) => ({
  method: 'PUT',
  url: `/modules/bank-holidays/days/${bankHolidayUUID}`,
  data
})

export const updateRegionTag = (regionTagUUID: string, data: Partial<IRegionTag>) => ({
  method: 'PUT',
  url: `/modules/bank-holidays/region-tags/${regionTagUUID}`,
  data
})

export const deleteBankHoliday = (bankHolidayUUID: string) => ({
  method: 'DELETE',
  url: `/modules/bank-holidays/days/${bankHolidayUUID}`
})

export const deleteRegionTag = (regionTagUUID: string) => ({
  method: 'DELETE',
  url: `/modules/bank-holidays/region-tags/${regionTagUUID}`
})

export const createBankHoliday = (data: ICreateBankHoliday) => ({
  method: 'POST',
  url: '/modules/bank-holidays/days',
  data
})

export const createRegionTag = (data: ICreateRegionTag) => ({
  method: 'POST',
  url: '/modules/bank-holidays/region-tags',
  data
})
